export { MyFreeDtvBanner as default } from "./MyFreeDirectvBanner";
export type { MyFreeDtvBannerProps, IMyFreeDtvChannel } from "./MyFreeDirectvBanner";
